/**
 * Import Dependency
 */
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'

/**
 * Import Component
 */
import About from '../../components/About'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    merchant: state.merchant,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {

  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(About)))



// WEBPACK FOOTER //
// ./src/containers/components/About.js